import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputTextModule } from 'primeng/inputtext';
import { CalendarModule } from 'primeng/calendar';
import { ButtonModule } from 'primeng/button';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { StepsModule } from 'primeng/steps';
import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { ChipsModule } from 'primeng/chips';
import { DropdownModule } from 'primeng/dropdown';
import { TagModule } from 'primeng/tag';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from "primeng/message"; 

import { TranslocoRootModule } from 'src/app/transloco-root.module';
import { HttpClientModule } from '@angular/common/http';
import { VcuComponent } from './vcu/vcu.component';
import { AccordionModule } from 'primeng/accordion';
import { TableModule } from 'primeng/table';
import { DashboardTemplateComponent } from '../dashboard/dashboard-template/dashboard-template.component';
import { InputIconModule } from 'primeng/inputicon';
import { IconFieldModule } from 'primeng/iconfield';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { RegisterModule } from '../register/register.module';
import { VcuManagementComponent } from './vcu-management/vcu-management.component';
import { VcuIdentifiedComponent } from './vcu-identified/vcu-identified.component';
import { ToastModule } from 'primeng/toast';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { CardModule } from '../card/card.module';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TooltipModule } from 'primeng/tooltip';
import { SharedModule} from '../../share/share.module';
import { VcuPairDialogComponent } from './vcu-pair-dialog/vcu-pair-dialog.component';
import { VcuCardPairComponent } from './vcu-card-pair/vcu-card-pair.component';
import { VcuListPairComponent } from './vcu-list-pair/vcu-list-pair.component';
import { VcuFileExplorerComponent } from './vcu-file-explorer/vcu-file-explorer.component';
import { CheckboxModule } from 'primeng/checkbox';
import { VcuTelemetryComponent } from './vcu-telemetry/vcu-telemetry.component';
import { ChartModule } from 'primeng/chart';
import { ProFeatureModalComponent } from 'src/app/share/pro-feature-modal/pro-feature-modal.component';

@NgModule({
  declarations: [
    VcuComponent,
    VcuManagementComponent,
    VcuIdentifiedComponent,
    VcuPairDialogComponent,
    VcuCardPairComponent,
    VcuListPairComponent,
    VcuTelemetryComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    DialogModule,
    StepsModule,
    InputTextModule,
    CalendarModule,
    ButtonModule,
    ReactiveFormsModule,
    ChipsModule,
    DropdownModule,
    TranslocoRootModule,
    HttpClientModule,
    AccordionModule,
    TableModule,
    InputIconModule,
    IconFieldModule,
    TagModule,
    MessagesModule,
    MessageModule,
    FormsModule,
    ConfirmDialogModule,
    DashboardTemplateComponent,
    RegisterModule,
    ToastModule,
    InputTextareaModule,
    CardModule,
    ProgressSpinnerModule,
    TooltipModule,
    SharedModule,
    CheckboxModule,
    ChartModule,
    ProFeatureModalComponent,
    VcuFileExplorerComponent
  ],
  exports: [
    VcuComponent,
    VcuManagementComponent,
    VcuIdentifiedComponent,
    VcuPairDialogComponent,
    VcuCardPairComponent,
    VcuListPairComponent,
    VcuFileExplorerComponent,
    VcuTelemetryComponent
  ],
  providers: [provideAnimations(), provideAnimationsAsync(), ConfirmationService, Title]
})
export class VcuModule { }
